<div 
	*ngIf="categoryNotFound" 
	id="maincontent" 
	tabindex="0" 
	[ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}"
>
	<h2>{{ 'Reports.CategoryNotFound' | translate: { categoryKey: categoryKey } }}</h2>
</div>
<ng-container *ngIf="!categoryNotFound">
    <div class="category-description" fxFlex="auto" fxLayout="column" fxLayoutGap="20px" [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">

        <div><img aria-hidden="true" alt="" src="assets/img/{{ (category | async)?.getIcon() }}_cat_icon.svg" /></div>
        <div class="title" id="maincontent" tabindex="0">{{ (category | async)?.title}}</div>
        <div tabindex="0">{{ (category | async)?.objective}}</div>
    </div>
    <app-report-listing *ngIf="reports.length>0" [reports]="reports"></app-report-listing>
</ng-container>